module.exports = __webpack_public_path__ + "img/telegram.c94cd3cf.svg";